export const generateColorImage = (color: string, width: number, height: number): Promise<string> => {
  return new Promise(resolve => {
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = width;
    tempCanvas.height = height;
    const ctx = tempCanvas.getContext('2d')!;
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, width, height);
    resolve(tempCanvas.toDataURL());
  });
};
